var _defs, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOphosTravelShadow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 307,
    viewBox: "0 0 198 307",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ophos-travel-shadow-a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "-2.049%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DCE0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7BDC1"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ophos-travel-shadow-a)",
    points: "274.223 2886 102 3192.395 210.528 3192.395 299.145 2886",
    transform: "translate(-102 -2886)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOphosTravelShadow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ophos-travel-shadow.c9f856ee.svg";
export { ForwardRef as ReactComponent };